import { Link } from 'react-router-dom';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription
} from '@/components/ui/card';

const SettingCard = ({ title, description, icon, to }) => {
  return (
    <Card className="max-w-[300px] min-w-[220px] flex-auto transition-opacity duration-300 ease-in-out hover:opacity-80">
      <Link to={to}>
        <CardHeader>
          <div className="flex gap-2">
            {icon}
            <div>
              <CardTitle className="flex justify-between items-center text-lg">
                {title}
              </CardTitle>
              <CardDescription>{description}</CardDescription>
            </div>
          </div>
        </CardHeader>
      </Link>
    </Card>
  );
};

export default SettingCard;
